import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { syncOfflineInvoices } from "../hooks/useOfflineInvoiceSync";
import { syncStockToLocal } from "../hooks/useOfflineSync";

/* ================= HOOK ================= */

export const useNetworkSync = () => {
  const { user, branch } = useAuth();

  useEffect(() => {
    if (!navigator.onLine) return;
    if (!user || !branch?.branch_id) return;

    const runSync = async () => {
      try {
        console.log("🔄 Sync started");

        // 1️⃣ FIRST inventory
        await syncStockToLocal(branch.branch_id);

        // 2️⃣ THEN invoices
        await syncOfflineInvoices();

        console.log("✅ Sync completed");
      } catch (err) {
        console.error("❌ Sync failed", err);
      }
    };

    runSync();
  }, [user, branch]);
};
